import map from "ramda/es/map";
import prop from "ramda/es/prop";
import flatten from "ramda/es/flatten";
import filter from "ramda/es/filter";
import includes from "ramda/es/includes";
import sum from "ramda/es/sum";
import pluck from "ramda/es/pluck";

import {
  CarbonImpactByScope,
  PlanComponent,
} from "@labs/shared/types/AnalyzedPlan.ts";
import { Scope } from "@labs/shared/types/Solution.ts";
import { scope1Fuels, scope2Fuels } from "../../data/scopeFuels.ts";

export const getCarbonImpactByScope = (
  planComponents: PlanComponent[],
): CarbonImpactByScope => {
  const allFuelImpacts = flatten(map(prop("fuelImpacts"), planComponents));

  const fuelImpactsScope1 = filter(
    (impact) => includes(impact.fuelSource, scope1Fuels),
    allFuelImpacts,
  );

  const fuelImpactsScope2 = filter(
    (impact) => includes(impact.fuelSource, scope2Fuels),
    allFuelImpacts,
  );

  const carbonImpactScope1 = sum(pluck("carbonImpact", fuelImpactsScope1));
  const carbonImpactScope2 = sum(pluck("carbonImpact", fuelImpactsScope2));

  return {
    [Scope.Scope1]: carbonImpactScope1,
    [Scope.Scope2]: carbonImpactScope2,
    [Scope.Scope3]: 0, // scope 3 not supported yet
  };
};
